import axios from 'axios'
import { defineStore } from 'pinia'

export interface SystemSupportInfo {
  email?: string | null
  phone?: string | null
  address?: string | null
}

export interface SystemFooterInfo {
  slogan?: string | null
  copyright?: string | null
  record?: string | null
}

export interface SystemInfo {
  name: string
  short_name?: string | null
  logo_url?: string | null
  url?: string | null
  enabled: boolean
  maintenance_message?: string | null
  support?: SystemSupportInfo
  footer?: SystemFooterInfo
  analytics?: string | null
}

let pending: Promise<SystemInfo | void> | null = null

export const useSystemStore = defineStore('system', {
  state: () => ({
    info: null as SystemInfo | null,
    loading: false,
  }),
  getters: {
    displayName: (state) =>
      state.info?.short_name ||
      state.info?.name ||
      '创新创业平台',
  },
  actions: {
    async ensureLoaded(force = false): Promise<SystemInfo | null> {
      if (this.info && !force) {
        return this.info
      }

      if (pending) {
        await pending
        return this.info
      }

      this.loading = true
      pending = axios
        .get<SystemInfo>('/api/v1/system/info')
        .then(({ data }) => {
          this.info = data
          return data
        })
        .finally(() => {
          this.loading = false
          pending = null
        })

      await pending
      return this.info
    },
    reset(): void {
      this.info = null
    },
  },
})
